import { render, staticRenderFns } from "./ContactStrip.vue?vue&type=template&id=efe2a690&scoped=true&"
import script from "./ContactStrip.vue?vue&type=script&setup=true&lang=js&"
export * from "./ContactStrip.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ContactStrip.vue?vue&type=style&index=0&id=efe2a690&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe2a690",
  null
  
)

export default component.exports